import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { Response } from "@app/models/util/response.model";
import { Question } from "@app/models/question.model";
import { ResponseQuestion } from "@app/models/responseQuestion.model";
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: "root",
})
export class SatisfactionService {
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  private resetRating: Subject<boolean> = new Subject();
  public resetRating$: Observable<boolean> = this.resetRating.asObservable();

  // properties
  private urlApi: string;
  private token : string;

  constructor(public http: HttpClient, ) {
    this.token = environment.newCoviFacturaApiKey;
    this.urlApi = `${environment.urlApiDev}/newcovifactura`;
  }

  setResetRating(value: boolean) {
    this.resetRating.next(value);
  }

  getUsersAnswers(userId: string) : Observable<any> {
    const headers = new HttpHeaders({
      "Authorization": `Basic ${btoa(this.token)}`
    });

    const params = { userId };

    return this.http.get(`${this.urlApi}/CoviFactura/respuestasSatisfaccion/obtenerRespuestas`, { headers, params })
  }

  getQuestions(idUsurio: number | string): Observable<Response<Question>> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/x-www-form-urlencoded");
    headers = headers.set(
      "Authorization",
      `Basic ${btoa(this.token)}`
    );

    const params = {
      idUsuario: idUsurio + "",
    };
    const options = { params, headers };
    return this.http
      .get(`${this.urlApi}/CoviFactura/preguntasSatisfaccion/obtenerPreguntas`, options)
      .pipe(
        map((response: Response<Question>) => {
          return response;
        })
      );
  }

  postResponseQuestion(
    responseQuestion: ResponseQuestion
  ): Observable<Response<ResponseQuestion>> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      `Basic ${btoa(this.token)}`
    );

    const options = { headers };
    return this.http
      .post(
        `${this.urlApi}/CoviFactura/respuestasSatisfaccion/guardarRespuesta`,
        responseQuestion,
        options
      )
      .pipe(
        map((response: Response<ResponseQuestion>) => {
          return response;
        })
      );
  }
}
